export default __webpack_public_path__ + "static/media/success002.ec5c594b.png";